import React from 'react';
import { ThemeMode } from '../features/theme/themeSlice';

interface ThemeToggleProps {
  mode: ThemeMode;
  onChange: (mode: ThemeMode) => void;
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  mode,
  onChange,
  className = ""
}) => {
  const modes: { value: ThemeMode; label: string }[] = [
    { value: 'light', label: 'Light' },
    { value: 'auto', label: 'Auto' },
    { value: 'dark', label: 'Dark' }
  ];

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="text-grey-30 dark:text-grey-70 px-2 text-xs font-semibold uppercase">
        Theme
      </div>
      <div className="space-y-1">
        {modes.map((modeItem) => (
          <button
            key={modeItem.value}
            type="button"
            onClick={() => onChange(modeItem.value)}
            className={`menu-link w-full ${mode === modeItem.value ? 'active' : ''}`}
            aria-label={`Switch to ${modeItem.label} theme`}
            aria-pressed={mode === modeItem.value}
          >
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {modeItem.value === 'light' && (
                <path
                  d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2ZM19.0711 4.92893C19.4616 5.31945 19.4616 5.95262 19.0711 6.34314L18.364 7.05025C17.9735 7.44077 17.3403 7.44077 16.9498 7.05025C16.5593 6.65972 16.5593 6.02656 16.9498 5.63603L17.6569 4.92893C18.0474 4.5384 18.6806 4.5384 19.0711 4.92893ZM4.92893 4.92893C5.31945 4.5384 5.95262 4.5384 6.34314 4.92893L7.05025 5.63603C7.44077 6.02656 7.44077 6.65972 7.05025 7.05025C6.65972 7.44077 6.02656 7.44077 5.63603 7.05025L4.92893 6.34314C4.5384 5.95262 4.5384 5.31945 4.92893 4.92893ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM2 12C2 11.4477 2.44772 11 3 11H4C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H3C2.44772 13 2 12.5523 2 12ZM19 12C19 11.4477 19.4477 11 20 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.4477 13 19 12.5523 19 12ZM16.9498 16.9497C17.3403 16.5592 17.9735 16.5592 18.364 16.9497L19.0711 17.6568C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711C18.6806 19.4616 18.0474 19.4616 17.6569 19.0711L16.9498 18.364C16.5593 17.9734 16.5593 17.3403 16.9498 16.9497ZM7.05025 16.9497C7.44077 17.3403 7.44077 17.9734 7.05025 18.364L6.34314 19.0711C5.95262 19.4616 5.31945 19.4616 4.92893 19.0711C4.5384 18.6805 4.5384 18.0474 4.92893 17.6568L5.63603 16.9497C6.02656 16.5592 6.65972 16.5592 7.05025 16.9497ZM12 19C12.5523 19 13 19.4477 13 20V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V20C11 19.4477 11.4477 19 12 19Z"
                  fill="#808080"
                />
              )}
              {modeItem.value === 'auto' && (
                <path
                  d="M12 2C11.4477 2 11 2.44772 11 3V4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55228 13 4V3C13 2.44772 12.5523 2 12 2ZM19.0711 4.92893C18.6806 4.5384 18.0474 4.5384 17.6569 4.92893L16.9498 5.63603C16.5593 6.02656 16.5593 6.65972 16.9498 7.05025C17.3403 7.44077 17.9735 7.44077 18.364 7.05025L19.0711 6.34314C19.4616 5.95262 19.4616 5.31945 19.0711 4.92893ZM20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11H20ZM6 12C6 8.68629 8.68629 6 12 6V18C8.68629 18 6 15.3137 6 12Z"
                  fill="#808080"
                />
              )}
              {modeItem.value === 'dark' && (
                <path
                  d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79Z"
                  fill="#808080"
                />
              )}
            </svg>
            {modeItem.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeToggle;
